import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class ListInvoiceApiRequest {
  page = 1;
  limit = 10;
  dateFrom = "";
  dateTo = "";
  search = "";
  status = "";
  sortBy = "";
  orderBy = "";

  constructor(fields?: Partial<ListInvoiceApiRequest>) {
    Object.assign(this, fields);
  }
  
  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}
